import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/security/components/SecurityConfidential/SecurityConfidential.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/security/components/SecurityHero/SecurityHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/security/components/SecuritySupport/SecuritySupport.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/security/components/SecurityTrust/SecurityTrust.tsx");
